import { Injectable } from '@angular/core';
import { Site } from '../api/device/models/site.interface';
import { Device } from '../api/device/models/device.interface';

@Injectable({ providedIn: 'root' })
export class DeviceAddStoreService {

  private serialNumber = '';
  private cloudPin = '';
  private site: Site = null;
  private options: DeviceOptions;

  private claimedDevice: Device = null;

  getSerialNumber(): string {
    return this.serialNumber;
  }

  setSerialNumber(value: string) {
    this.serialNumber = value;
  }

  getCloudPin(): string {
    return this.cloudPin;
  }

  setCloudPin(value: string) {
    this.cloudPin = value;
  }

  getSite(): Site {
    return this.site;
  }

  setSite(value: Site) {
    this.site = value;
  }

  getClaimedDevice(): Device {
    return this.claimedDevice;
  }

  setClaimedDevice(claimedDevice: Device) {
    this.claimedDevice = claimedDevice;
  }

  getOptions() {
    return this.options;
  }

  setOptions(options: DeviceOptions) {
    this.options = options;
  }

  clean(): void {
    this.serialNumber = '';
    this.cloudPin = '';
    this.site = null;
    this.claimedDevice = null;
    this.options = null;
  }
}

export interface DeviceOptions {
  deviceName?: string;
  deviceConfig?: Device;
  img?: {
    url: string,
    blob: Blob
  };
}
